<template>
  <div id="drop-area">
    <v-container>
      <v-row>
        <v-col cols="12" class="text-center pa-0">
          <slot v-if="rulePass && !uploading" name="text">{{ text }}</slot>
          <v-btn v-if="rulePass && !uploading" @click="openFolder" icon
            ><v-icon>mdi-folder</v-icon></v-btn
          >
          <span v-if="!rulePass" class="body-2 red--text text--lighten-1"
            ><v-icon color="red" class="pr-1">mdi-alert-rhombus-outline</v-icon
            >{{ alertComment }}</span
          >
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="text-center pa-0">
          <v-progress-circular
            v-if="uploading"
            indeterminate
            color="primary"
          ></v-progress-circular>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
export default {
  props: ["text", "type", "length", "size", "multiple", "uploading"],
  data: function() {
    return {
      files: [],
      alertComment: "",
      rulePass: true,
      dropArea: null
    };
  },
  watch: {
    rulePass: function(newVal) {
      const vm = this;
      console.log(newVal);
      if (!newVal) {
        setTimeout(function() {
          vm.rulePass = true;
          vm.alertComment = "";
        }, 3000);
      }
    }
  },
  methods: {
    init() {
      this.dropArea = document.getElementById("drop-area");

      ["dragenter", "dragover", "dragleave", "drop"].forEach(eventName => {
        this.dropArea.addEventListener(eventName, this.preventDefaults, false);
      });

      ["dragenter", "dragover"].forEach(eventName => {
        this.dropArea.addEventListener(eventName, this.highlight, false);
      });
      ["dragleave", "drop"].forEach(eventName => {
        this.dropArea.addEventListener(eventName, this.unhighlight, false);
      });

      this.dropArea.addEventListener("drop", this.handleDrop, false);
    },
    preventDefaults(e) {
      e.preventDefault();
      e.stopPropagation();
    },
    highlight() {
      this.dropArea.classList.add("highlight");
    },

    unhighlight() {
      this.dropArea.classList.remove("highlight");
    },
    handleDrop(e) {
      let dt = e.dataTransfer;
      let fileList = dt.files;
      // fileList 객체를 배열로 변환
      let files = [];
      for (const property in fileList) {
        if (property != "length" && property != "item") {
          const file = fileList[property];
          files.push(file);
        }
      }
      this.handleFiles(files);
    },
    handleFiles(files) {
      if (this.ruleCheck(files) === true) {
        this.$emit("uploadfile", files);
      }
    },
    ruleCheck(files) {
      console.log(
        "rule check start",
        files,
        files.length,
        this.multiple,
        !this.multiple
      );
      if (this.multiple == "false" && files.length > 1) {
        this.rulePass = false;
        this.alertComment = "Multiple files not allowed!";
        return this.rulePass;
      }

      const totalUploadingCount =
        this.$store.state.uploadingContent.length + files.length;
      if (totalUploadingCount > 12) {
        this.rulePass = false;
        this.alertComment = "You can upload up to 12 files at a time.";
        return this.rulePass;
      }

      for (var i = 0; i < files.length; i++) {
        const name = files[i].name;
        const size = files[i].size;
        const type = files[i].type;
        console.log(files[i]);
        console.log(name, size, type, this.length, this.size, this.type);
        const types = this.type.split(",");
        console.log(
          "types",
          types,
          !types.some(f => {
            console.log({ f, type });
            return f.trim() == type;
          })
        );
        if (!types.some(f => f.trim() == type)) {
          this.rulePass = false;
          this.alertComment = "Invalid Mime-Type";
          break;
        }

        if (size > this.size * 1024 * 1024) {
          console.log(size, this.size * 1024 * 1024);
          this.rulePass = false;
          this.alertComment = `File's size must be less than ${this.size}MB`;
          break;
        }
        if (name.length - 4 > this.length) {
          console.log(name.length);
          this.rulePass = false;
          this.alertComment = `File's name must be less than ${this.length}`;
          break;
        }
      }
      return this.rulePass;
    },
    async openFolder() {
      let files = [];
      const multipleBoolean = this.multiple == "false" ? false : true;
      const getFiles = await this.selectFile(this.type, multipleBoolean);
      console.log("open folder", getFiles);

      if (!Array.isArray(getFiles)) {
        files.push(getFiles);
      } else {
        files = getFiles;
      }
      this.handleFiles(files);
    },
    selectFile(type, multiple) {
      return new Promise(resolve => {
        let input = document.createElement("input");
        input.type = "file";
        input.multiple = multiple;
        input.accept = type;

        input.onchange = () => {
          let files = Array.from(input.files);
          if (multiple) resolve(files);
          else resolve(files[0]);
        };

        input.click();
      });
    }
  },
  mounted: function() {
    this.init();
  }
};
</script>
<style scoped>
#drop-area {
  border: 2px dashed #ccc;
  border-radius: 20px;
  width: 480px;
  font-family: sans-serif;
  margin: 10px auto;
  padding: 20px;
  width: 100%;
}
#drop-area.highlight {
  border-color: purple;
}
p {
  margin-top: 0;
}
.my-form {
  margin-bottom: 10px;
}
#gallery {
  margin-top: 10px;
}
#gallery img {
  width: 150px;
  margin-bottom: 10px;
  margin-right: 10px;
  vertical-align: middle;
}
.button {
  display: inline-block;
  padding: 10px;
  background: #ccc;
  cursor: pointer;
  border-radius: 5px;
  border: 1px solid #ccc;
}
.button:hover {
  background: #ddd;
}
#fileElem {
  display: none;
}
</style>
